// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sCaB","newExpiryDate":"styles_newExpiryDate__2uPrz","footer":"styles_footer__3qpNF"};